var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container",attrs:{"id":"app"}},[_c('router-view'),_c('img',{staticClass:"default_img_app",attrs:{"src":require('@/assets/images/logo/logo.png'),"alt":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }